import Swiper, { Autoplay, Pagination } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';
let jobDescrSwiperWr = document.querySelectorAll('.job-descr__aside-swiper-wr');
jobDescrSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
     let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let paginationEl = el.querySelector('.swiper-pagination');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 24,
      slidesPerView: 1,
      pagination: {
        clickable: true,
        el: paginationEl,
        bulletActiveClass: 'swiper-pagination-bullet-active',
        bulletClass: 'swiper-pagination-bullet',
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
    });
    swiperObserver(swiper);
  }
});